import { GridRow, GridRowProps } from '@mui/x-data-grid-pro';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/system';
import { WithTheme } from '@issuemanager/apps/client/theme';
import { MasterIssueRowModel } from './types';

export const ACTION_NO_VISIBLE = 'action-no-visible';
export const ACTIONS_ARE_LOADING = 'actions-are-loading';

type StyledIssueGridRowProps = {
  rowHeight: number | 'auto';
};

const StyledIssueGridRow = styled(Box)<WithTheme<StyledIssueGridRowProps>>(
  ({ rowHeight }) => ({
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 50,
    width: '100%',
    boxSizing: 'border-box',
    height: rowHeight,
  }),
);

export function IssueGridRow(props: GridRowProps) {
  const { t } = useTranslation(['issue']);

  const row = props.row as MasterIssueRowModel;
  if (row.path.length > 1 && row.path[1].includes(ACTION_NO_VISIBLE)) {
    return (
      <StyledIssueGridRow
        itemProp={ACTION_NO_VISIBLE}
        rowHeight={props.rowHeight}
      >
        <Typography>{t('list.table.actionNoVisible')}</Typography>
      </StyledIssueGridRow>
    );
  } else if (row.path.length > 1 && row.path[1].includes(ACTIONS_ARE_LOADING)) {
    return (
      <StyledIssueGridRow
        itemProp={ACTIONS_ARE_LOADING}
        rowHeight={props.rowHeight}
      >
        <Typography>{t('list.table.actionAreLoading')}</Typography>
      </StyledIssueGridRow>
    );
  }
  return <GridRow {...props} />;
}
